import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useListManualQueryDocuments = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const fetchDocuments = async () => {
    if (organizationId) {
      return await api.listManualQueryDocuments({ token, organizationId })
    }
  }

  return useDataLoader(fetchDocuments, [], [])
}

export default useListManualQueryDocuments
